/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
window.onload = function() {
  document.getElementsByClassName('powrMark__logo-block').style.display = 'none';
  document.getElementsByClassName('powrMark__text').style.display = 'none';
  
};